import { render } from "./ExternalLinks.vue?vue&type=template&id=a8bf9f22"
import script from "./ExternalLinks.vue?vue&type=script&lang=js"
export * from "./ExternalLinks.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__